import { OperatorConstants } from "../models/TrafficFilterModel.js";
import "../models/index.js";
import { ProgressionSettingsType } from "../models/FeatureDataModel.js";
const getDefaultProgressionSettingsType = () => {
  return {
    id: ProgressionSettingsType.SingleTreatmentProgressionSettings,
    displayName: "Standard Progression",
    description: ""
  };
};
const getDefaultProgressionSettingsMetadata = () => {
  const defaultMetadata = {
    SingleTreatmentProgressionSettings: {
      DisplayName: "Standard progression",
      Description: "Rollout feature by audiences"
    },
    ABnProgressionSettings: {
      DisplayName: "A/B/n experiment",
      Description: "The A/B/n experiment progression allows you to run AB test against a set of flights before picking a winning flight to rollout"
    },
    OverrideSetProgressionSettings: {
      DisplayName: "Override progression",
      Description: "Progressively rollout a flight. This progression type allows overlapping filters but cannot specify traffic percentages."
    }
  };
  return defaultMetadata;
};
const getDefaultProgressionSelectionTemplates = () => {
  return {
    progressionName: "",
    selectedProgressionTemplateName: "",
    progressionTemplateOptions: {},
    initialTrafficFilters: {
      trafficFilters: {}
    },
    selectedTrafficFilters: {
      trafficFilters: {}
    },
    initialFreeFormTrafficFilters: {
      trafficFilters: {}
    },
    allowAdditionalFilters: true,
    stageTrafficFilterKeys: [],
    progressionSettingsType: null,
    selectedFlights: [],
    selectedProgressionTemplateId: "",
    supportedProgressionTypes: [],
    trafficAllocation: null
  };
};
const getInitialComplexFilter = () => {
  return {
    trafficFilterRule: {
      [OperatorConstants.In]: []
    },
    currentSelectedOperator: OperatorConstants.In,
    selectedBaseOperators: [OperatorConstants.In]
  };
};
const getInitialProgressionSelectionTemplates = () => getDefaultProgressionSelectionTemplates();
const getInitialMdsFilters = () => {
  return {};
};
const getInitialTrafficFilters = () => {
  return {
    trafficFilters: {}
  };
};
const getInitialProgressionTemplates = () => {
  return {};
};
const getInitialMdsSnapshotProgressionTemplatesMap = () => {
  return {};
};
export {
  getDefaultProgressionSelectionTemplates,
  getDefaultProgressionSettingsMetadata,
  getDefaultProgressionSettingsType,
  getInitialComplexFilter,
  getInitialMdsFilters,
  getInitialMdsSnapshotProgressionTemplatesMap,
  getInitialProgressionSelectionTemplates,
  getInitialProgressionTemplates,
  getInitialTrafficFilters
};
//# sourceMappingURL=ProgressionSelectionInitialData.js.map
